import { ArrowRight, Send } from "lucide-react";
import { Reveal } from "@/components/landing/primitives";
import { NAV_LINKS, SOCIALS } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative pt-20 pb-10 border-t border-white/5 overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 radial-gold opacity-40" />
      <div className="container-trt relative z-10">
        {/* CTA */}
        <Reveal>
          <div className="glass-gold rounded-3xl p-8 md:p-12 text-center gold-glow mb-16">
            <h2 className="font-display text-3xl md:text-5xl font-extrabold leading-tight">
              Ready to own the future of <span className="gold-text">real-world assets?</span>
            </h2>
            <p className="mt-4 text-[var(--muted)] max-w-xl mx-auto">
              Join thousands of investors building wealth on TRT — tokenized, transparent and on-chain.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <a href="#top" className="btn-gold" data-testid="footer-cta">Launch App <ArrowRight className="w-4 h-4" /></a>
              <a href="#faq" className="btn-ghost">Read the docs</a>
            </div>
          </div>
        </Reveal>

        {/* Links grid */}
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <img src="/trst-logo.png" alt="TRT logo" className="w-10 h-10 rounded-full object-contain drop-shadow-[0_0_10px_rgba(244,201,93,0.45)]" />
              <div className="font-display font-extrabold text-lg">TRT</div>
            </div>
            <p className="mt-4 text-sm text-[var(--muted)] leading-relaxed max-w-xs">
              The Real Token — an AI-powered, EVM-compatible blockchain ecosystem for tokenized real-world assets.
            </p>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-[var(--gold-2)] mb-4">Ecosystem</div>
            <ul className="space-y-2.5">
              {NAV_LINKS.slice(0, 5).map((l) => (
                <li key={l.href}><a href={l.href} className="text-sm text-[var(--muted)] hover:text-[var(--gold-2)] transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-[var(--gold-2)] mb-4">Community</div>
            <ul className="space-y-2.5">
              {SOCIALS.map((s) => (
                <li key={s}><a href="#top" className="text-sm text-[var(--muted)] hover:text-[var(--gold-2)] transition-colors">{s}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-[var(--gold-2)] mb-4">Newsletter</div>
            <p className="text-sm text-[var(--muted)] mb-3">Get TRT updates & drops.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="your@email.com"
                className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 text-sm outline-none focus:border-[var(--gold-3)] transition-colors"
                data-testid="newsletter-input"
              />
              <button className="btn-gold !px-4" data-testid="newsletter-submit"><Send className="w-4 h-4" /></button>
            </div>
          </div>
        </div>

        <div className="divider my-10" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[var(--muted)] font-mono">
          <span>© {new Date().getFullYear()} TRT — The Real Token. All rights reserved.</span>
          <span>Built for a tokenized world · Non-custodial · Audited</span>
        </div>
      </div>
    </footer>
  );
}
